import { useEffect } from 'react';
import { useSupabaseAuth } from '@/hooks/auth';
import { checkAndStartPracticeGeneration } from '@/services/practiceLabBootstrap';

/**
 * Auto-starts content generation for admin/staff users on app load
 * Checks for missing practice labs and triggers generation if needed
 */
export const ContentGenerationBootstrap = () => {
  const { user } = useSupabaseAuth();

  useEffect(() => {
    const initializeGeneration = async () => {
      if (!user) return;

      // Get user role from metadata
      const userRole = user.user_metadata?.role || 'user';
      
      // Only run for admin/staff
      if (['admin', 'staff'].includes(userRole)) {
        console.log('🚀 Admin/Staff detected - checking content generation status...');
        await checkAndStartPracticeGeneration(userRole);
      }
    };

    initializeGeneration();
  }, [user]);

  return null; // This is a logic-only component
};
